





































































import Vue, { PropType } from "vue";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import IconButton from "@/components/IconButton.vue";
import NavigationButton from "@/components/NavigationButton.vue";
import SyncStatusBadge from "../SyncStatusBadge.vue";
import DateTimeDisplay from "@/components/DateTimeDisplay.vue";
import InvoiceDetails from "../detailViews/InvoiceDetails.vue";
import InvoiceInfo from "../detailViews/InvoiceInfo.vue";
import IfaceSyncInvoiceHeadDTO from "../../models/IfaceSyncInvoiceHeadDTO";
import { ColumnType } from "@/components/apiSearch/models/ApiSearch";
import store from "../../services/InterfaceStore";
import { t } from "@/plugins/i18n";

interface Props {
  /** Csoportosító külső azonosító (a fejlécben jelenik meg, és ezt szűri a search) */
  extCode: string;
  /** Az aktuális számla rekord (kompakt összegzéshez) */
  invoice: IfaceSyncInvoiceHeadDTO | null;
}

interface Computed {
  url: string;
  apiSearchName: string;
  columns: any[];
}

export default Vue.extend<{}, {}, Computed, Props>({
  name: "InvoiceHistory",

  components: {
    ApiSearchPage,
    IconButton,
    NavigationButton,
    SyncStatusBadge,
    DateTimeDisplay,
    InvoiceDetails,
    InvoiceInfo,
  },

  props: {
    extCode: { type: String, default: "" },
    invoice: { type: Object as PropType<IfaceSyncInvoiceHeadDTO | null>, default: null },
  },

  computed: {
    url(): string {
      return `iface-sync-invoice-head/history-search/${store.selectedInterface}/${encodeURIComponent(this.extCode)}`;
    },

    apiSearchName(): string {
      return `InvoiceHistoryApiSearch_${this.extCode}`;
    },

    columns(): any[] {
      const commandCol = {
        field: "command",
        title: "",
        cell: "command",
        filterable: false,
        sortable: false,
        width: 85,
      };

      return [
        commandCol,
        { field: "updDateTime", title: t("Interface_Idopont"), width: 110, filterable: false, cell: "updDateTime" },
        { field: "syncStatusName", title: t("Statusz"), width: 140, cell: "syncStatusName" },
        { field: "invNo", title: t("KulsoSzamlaszam"), width: 160, cell: "disabledText" },
        { field: "partnerCode", title: t("Interface_PartnerKod"), width: 130, cell: "disabledText" },
        { field: "invDate", title: t("SzamlaDatuma"), width: 110, type: ColumnType.Date, filterable: false },
        { field: "total", title: t("Brutto"), width: 110, type: ColumnType.Money, filterable: false },
        { field: "invCurrency", title: "P.nem", width: 70, cell: "disabledText" },
        { field: "errorText", title: t("Hibauzenet"), width: 200, cell: "disabledText" },
        { field: "syncRemark", title: t("Megjegyzes"), width: 180, cell: "disabledText" },
        { field: "updUserName", title: t("Interface_Modositotta"), width: 130, cell: "disabledText" },
      ];
    },
  },
});
